import { useBusinessService } from '@ingenico/react-section-utils';
import { useCallback } from 'react';
import { firstValueFrom } from 'rxjs';
import { DeviceManagementService } from '../domain/business/services/deviceManagement.service';

export function useDataFilePreviewClick() {
  const configurationService = useBusinessService(DeviceManagementService);
  return useCallback(
    (resourceId: string) => {
      const previewTab = window.open('', '_blank');
      void firstValueFrom(configurationService.getDataFileArtifactBlob(resourceId))
        .then((blob) => {
          if (!previewTab) return;
          const img = previewTab.document.createElement('img');
          const objectUrl = URL.createObjectURL(blob);
          img.onload = () => URL.revokeObjectURL(objectUrl);
          img.src = objectUrl;
          img.style.maxWidth = '100%';
          img.style.height = 'auto';
          previewTab.document.body.style.margin = '0';
          previewTab.document.body.appendChild(img);
        })
        .catch(() => {
          previewTab?.close();
        });
    },
    [configurationService],
  );
}
